export const PRODUCT_COLOR_VALUES = {
  Black: { hex: "#1a1a1a", label: { en: "Black", ar: "أسود" } },
  Blue: { hex: "#2563eb", label: { en: "Blue", ar: "أزرق" } },
  Green: { hex: "#00a44f", label: { en: "Green", ar: "أخضر" } },
  Red: { hex: "#dc2626", label: { en: "Red", ar: "أحمر" } },
  Yellow: { hex: "#eab308", label: { en: "Yellow", ar: "أصفر" } },
  "RAL 3011 - Brown Red": {
    hex: "#7e292c",
    label: { en: "RAL 3011 - Brown Red", ar: "RAL 3011 - بني محمر" },
  },
  "RAL 3020 - Traffic Red": {
    hex: "#bb1e10",
    label: { en: "RAL 3020 - Traffic Red", ar: "RAL 3020 - أحمر مروري" },
  },
  "RAL 5012 - Light Blue": {
    hex: "#0081a2",
    label: { en: "RAL 5012 - Light Blue", ar: "RAL 5012 - أزرق فاتح" },
  },
  "RAL 5015 - Sky Blue": {
    hex: "#007ab3",
    label: { en: "RAL 5015 - Sky Blue", ar: "RAL 5015 - أزرق سماوي" },
  },
  "RAL 5030 - Stone Blue": {
    hex: "#37474f",
    label: { en: "RAL 5030 - Stone Blue", ar: "RAL 5030 - أزرق حجري" },
  },
  "RAL 6010 - Grass Green": {
    hex: "#00694c",
    label: { en: "RAL 6010 - Grass Green", ar: "RAL 6010 - أخضر عشبي" },
  },
};

export function getColorHex(name) {
  return PRODUCT_COLOR_VALUES[name]?.hex || "#cbd5e1";
}

export function getColorLabel(name, language) {
  const lang = language?.startsWith("ar") ? "ar" : "en";
  return PRODUCT_COLOR_VALUES[name]?.label?.[lang] || name;
}

export function extractProductColors(attributes = []) {
  const colorAttr = attributes.find(
    (attr) =>
      attr.slug === "pa_color" || String(attr.name || "").toLowerCase() === "color",
  );

  return (colorAttr?.options || []).filter(Boolean);
}

export function buildCartKey(productId, color = "") {
  return color ? `${productId}::${color}` : String(productId);
}

export function resolveCartKey(item) {
  if (!item) return "";
  if (item.cartKey) return item.cartKey;
  return buildCartKey(item.id, item.color || "");
}
